import React from 'react';
import { BaseResourceListProps, SimpleList, SvgEdit } from '@app/components';
import { taxApi } from '@app/store';
import { ITax } from '@app/common';
import { theme } from '@app/theme';
import { createColumnHelper } from '@tanstack/react-table';
import { useTable } from '@app/hooks/useTable';
import { CheckPermissions } from '@app/components/CheckPermissions';

const columnHelper = createColumnHelper<ITax>();

export const TaxList = ({ onUpdate, onRowPress, selectedRowItem }: BaseResourceListProps<ITax>) => {
  const columns = [
    columnHelper.accessor('name', {
      header: () => (
        <SimpleList.HeaderItem width="35%">
          <SimpleList.HeaderItemLabel>Nom</SimpleList.HeaderItemLabel>
        </SimpleList.HeaderItem>
      ),
      cell: (info) => (
        <SimpleList.ItemCol width="35%">
          <SimpleList.ItemText align="left" bold numberOfLines={2} active={info.active}>
            {info.getValue()}
          </SimpleList.ItemText>
        </SimpleList.ItemCol>
      ),
    }),
    columnHelper.accessor('codeVAT', {
      header: () => (
        <SimpleList.HeaderItem width="20%">
          <SimpleList.HeaderItemLabel>Code VAT</SimpleList.HeaderItemLabel>
        </SimpleList.HeaderItem>
      ),
      cell: (info) => (
        <SimpleList.ItemCol width="20%">
          <SimpleList.ItemText align="left" bold numberOfLines={1} active={info.active}>
            {info.getValue()}
          </SimpleList.ItemText>
        </SimpleList.ItemCol>
      ),
    }),
    columnHelper.accessor('salesCodeHT', {
      header: () => (
        <SimpleList.HeaderItem width="20%">
          <SimpleList.HeaderItemLabel>Code vente HT</SimpleList.HeaderItemLabel>
        </SimpleList.HeaderItem>
      ),
      cell: (info) => (
        <SimpleList.ItemCol width="20%">
          <SimpleList.ItemText align="left" bold numberOfLines={1} active={info.active}>
            {info.getValue()}
          </SimpleList.ItemText>
        </SimpleList.ItemCol>
      ),
    }),
    columnHelper.accessor('rate', {
      header: () => (
        <SimpleList.HeaderItem width="20%">
          <SimpleList.HeaderItemLabel>Taux</SimpleList.HeaderItemLabel>
        </SimpleList.HeaderItem>
      ),
      cell: (info) => (
        <SimpleList.ItemCol width="20%">
          <SimpleList.ItemText align="left" bold numberOfLines={1} active={info.active}>
            {info.getValue()}%
          </SimpleList.ItemText>
        </SimpleList.ItemCol>
      ),
    }),
    columnHelper.display({
      id: 'actions',
      header: () => (
        <SimpleList.HeaderItem width="25%" align='center'>
          <SimpleList.HeaderItemLabel>Actions</SimpleList.HeaderItemLabel>
        </SimpleList.HeaderItem>
      ),
      cell: ({ row, active }) => (
        <SimpleList.ItemCol width="25%">
          <SimpleList.ItemActions>
            <CheckPermissions permissions={['dashboard::taxes.update']}>
              <SimpleList.ItemAction onPress={() => onUpdate(row.original)}>
                <SvgEdit color={active ? '#FFF' : theme.colors.celadonblue} />
              </SimpleList.ItemAction>
            </CheckPermissions>
          </SimpleList.ItemActions>
        </SimpleList.ItemCol >
      ),
    }),
  ];

  const { table, setSearch, isFetching } = useTable({
    columns,
    useQuery: ({ pagination, search }) => taxApi.useReadManyTaxQuery({
      pagination,
      filters: {
        name: {
          $contains: search
        }
      },
      sort: ['name:ASC'],
    })
  });

  return <SimpleList
    table={table}
    isFetching={isFetching}
    onSearch={setSearch}
    selectedRowItem={selectedRowItem}
    onRowPress={onRowPress} />;
};

